import actionTypes from '../actionTypes';

export function requestExchangeSapphires({ amount, changeTo }) {
  return {
    type: actionTypes.EXCHANGE_SAPPHIRES_REQUEST,
    amount,
    changeTo
  };
}

export function successExchangeSapphires () {
  return {
    type: actionTypes.EXCHANGE_SAPPHIRES_SUCCESS
  };
}

export function failClubTables  () {
  return {
    type: actionTypes.TABLES_FAILURE
  };
}
